import PropTypes from 'prop-types'

export const CATEGORY_TYPE = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  name: PropTypes.string,
  slug: PropTypes.string,
})

export const CATEGORIES_TYPE = PropTypes.arrayOf(CATEGORY_TYPE)

/**
 * @deprecated Use PRIMARY_GROWTH_CAT_AND_SUBCAT_TYPE
 */
export const PRIMARY_CAT_AND_SUBCAT_TYPE = PropTypes.shape({
  primaryCategory: CATEGORY_TYPE,
  primarySubcategory: CATEGORY_TYPE,
})

export const PRIMARY_GROWTH_CAT_AND_SUBCAT_TYPE = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  parentId: PropTypes.number,
  uuid: PropTypes.string.isRequired,
  rankings: PropTypes.arrayOf(
    PropTypes.shape({
      rankValue: PropTypes.number.isRequired,
      rankType: PropTypes.string.isRequired,
    }),
  ),
})

export const PrimaryCategoryAndSubcategoryPropType = PropTypes.shape({
  primaryCategory: PRIMARY_GROWTH_CAT_AND_SUBCAT_TYPE.isRequired,
  primarySubcategory: PRIMARY_GROWTH_CAT_AND_SUBCAT_TYPE.isRequired,
})
